import totalIcon from '../../Assets/images/svg/total_active.svg';
import appIcon from '../../Assets/images/svg/app_mode.svg';
import dataIcon from '../../Assets/images/svg/data_mode.svg';
import infraIcon from '../../Assets/images/svg/infra_mode.svg';
import technologyIcon from '../../Assets/images/svg/technology.svg';
import deliveryIcon from '../../Assets/images/svg/delivery_excellence.svg';
import productsIcon from '../../Assets/images/svg/products_platform.svg';
import humanIcon from '../../Assets/images/svg/human_resources.svg';
import humanIconOld from '../../Assets/images/svg/human_resources_old.svg';
import appIconOld from '../../Assets/images/svg/app_mode_old.svg';
import dataIconOld from '../../Assets/images/svg/data_mode_old.svg';
import infraIconOld from '../../Assets/images/svg/infra_mode_old.svg';
import technologyIconOld from '../../Assets/images/svg/technology_old.svg';
import deliveryIconOld from '../../Assets/images/svg/delivery_excellence_old.svg';
import productsIconOld from '../../Assets/images/svg/product_platform_old.svg';
import adminAndOperationIconOld from '../../Assets/images/svg/admin_and_operations_old.svg';
import customerEngineeringIconOld from '../../Assets/images/svg/customer_engineering_old.svg';
import financeIconOld from '../../Assets/images/svg/finance_old.svg';
import marketingIconOld from '../../Assets/images/svg/marketing_old.svg';
import salesIconOld from '../../Assets/images/svg/sales_old.svg';
import appModAndcustomerEngineer from '../../Assets/images/svg/app_mode_customer_engineering.svg';
import cloudOpsIcon from '../../Assets/images/svg/cloudops_icon.svg';

import UseAxios from '../../Api/http/http';
import {
  certificationsVerticalCount,
  getTargetsDataUsingFlag,
} from '../../Api/request/certification';
import { certificationMapList } from '../../Api/request/certificationmap';

export const verticalMap = {
  'Total active': {
    icon: totalIcon,
    activeIcon: totalIcon,
    value: '0 (0)',
  },
  'App Mod': {
    icon: appIconOld,
    activeIcon: appIcon,
    value: '0 (0)',
  },
  'Infra Mod': {
    icon: infraIconOld,
    activeIcon: infraIcon,
    value: '0 (0)',
  },
  'Data Mod': {
    icon: dataIconOld,
    activeIcon: dataIcon,
    value: '0 (0)',
  },
  Marketing: {
    icon: marketingIconOld,
    activeIcon: marketingIconOld,
    value: '0 (0)',
  },
  Sales: {
    icon: salesIconOld,
    activeIcon: salesIconOld,
    value: '0 (0)',
  },
  'Delivery Excellence': {
    icon: deliveryIconOld,
    activeIcon: deliveryIcon,
    value: '0 (0)',
  },
  'Customer Engineering': {
    icon: customerEngineeringIconOld,
    activeIcon: customerEngineeringIconOld,
    value: '0 (0)',
  },
  'Admin & Operations': {
    icon: adminAndOperationIconOld,
    activeIcon: adminAndOperationIconOld,
    value: '0 (0)',
  },
  Finance: {
    icon: financeIconOld,
    activeIcon: financeIconOld,
    value: '0 (0)',
  },
  'Human Resources': {
    icon: humanIconOld,
    activeIcon: humanIcon,
    value: '0 (0)',
  },
  Technology: {
    icon: technologyIconOld,
    activeIcon: technologyIcon,
    value: '0 (0)',
  },
  CloudOps: {
    icon: cloudOpsIcon,
    activeIcon: cloudOpsIcon,
    value: '0 (0)',
  },
  'Products & Platforms': {
    icon: productsIconOld,
    activeIcon: productsIcon,
    value: '0 (0)',
  },
  'App Mod & Customer Engineering': {
    icon: appModAndcustomerEngineer,
    activeIcon: appModAndcustomerEngineer,
    value: '0 (0)',
  },

};

//  Helper function for getCertificationsTabsData
const processVerticalMap = (vmap, dMap) => {
  let totalEmployeeCount = 0;

  vmap.forEach((el) => {
    const verticalName = el.vertical.trim();
    const filteredTitle = dMap.find((item) => item.title === verticalName);
    if (filteredTitle) {
      filteredTitle.value = `${el.certificationCount} (${el.employeeCount})`;
      filteredTitle.icon = verticalMap[verticalName]?.icon || '';
    } else {
      dMap.push({
        title: verticalName,
        value: `${el.certificationCount} (${el.employeeCount})`,
        icon: verticalMap[verticalName]?.icon || '',
      });
    }
    totalEmployeeCount += el.employeeCount;
  });

  return totalEmployeeCount;
};

const getCertificationsTabsData = () => {
  return new Promise((resolve, reject) => {
    UseAxios(certificationsVerticalCount())
      .then((response) => {
        const vmap = response.data.activeCertificationsMap;

        const dMap = Object.keys(verticalMap).map((key) => {
          const el = verticalMap[key];
          return {
            title: key,
            value: el.value,
            icon: el.icon,
          };
        });

        const totalEmployeeCount = processVerticalMap(vmap, dMap);

        const totalActiveIndex = dMap.findIndex((item) => item.title === 'Total active');
        if (totalActiveIndex !== -1) {
          dMap[totalActiveIndex].value = `${response.data.totalActiveCertifications} (${totalEmployeeCount})`;
        }

        dMap.sort((itemA, itemB) => {
          const aCertCount = parseInt(itemA.value.split(' ')[0]);
          const bCertCount = parseInt(itemB.value.split(' ')[0]);
          return bCertCount - aCertCount;
        });

        resolve(dMap);
      })
      .catch((error) => {
        console.error('Error fetching certification tabs data:', error);
        reject(new Error('Promise rejected'));
      });
  });
};

const fetchTargetPieData = (selectedYear) => {
  return new Promise((resolve, reject) => {
    UseAxios(certificationMapList(null, null, null, selectedYear))
      .then((response) => {
        const result = response.data;
        if (result?.response && result.response.data.statusCode === 441) {
          reject(new Error('No data available for the selected year'));
        } else {
          const certificationCounts = result.certificationMapDetails.reduce(
            (acc, item) => {
              if (!acc) acc = {}; // Initialize acc if it's undefined
              if (item.isDeleted === true || item.employeeStatus == 'Exit') {
                return acc;
              }
              if (!acc[item.certifications]) {
                acc[item.certifications] = 0;
              }
              acc[item.certifications] += 1;
              return acc;
            },
            {},
          );
          const transformedData = Object.entries(certificationCounts).map(([certification, count], index) => ({
            id: index,
            value: count,
            label: certification,
          }));

          const totalValue = transformedData.reduce((sum, item) => sum + item.value, 0);
          resolve({ mData: transformedData, totalValue });
        }
      })
      .catch((error) => {
        console.error('Error fetching target pie data:', error);
        reject(new Error('Promise rejected'));
      });
  });
};

const getTargetsData = (selectedYear) => {
  return new Promise((resolve, reject) => {
    UseAxios(getTargetsDataUsingFlag(selectedYear))
      .then((response) => {
        const result = response.data;
        if (result.response && result.response.data.statusCode === 441) {
          reject(new Error('No data available for the selected year'));
        } else {
          const { targetDetails, yearlyUniqueCount } = result;
          resolve({ targetDetails, yearlyUniqueCount });
        }
      })
      .catch((error) => {
        console.error('Error fetching targets data:', error);
        reject(new Error('Promise rejected'));
      });
  });
};

export { getCertificationsTabsData, fetchTargetPieData, getTargetsData };

